import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"

export const FETCH_RAPPROCHEMENT_BEGIN = "FETCH_RAPPROCHEMENT_BEGIN"
export const FETCH_RAPPROCHEMENT_SUCCESS = "FETCH_RAPPROCHEMENT_SUCCESS"
export const FETCH_RAPPROCHEMENT_ERROR = "FETCH_RAPPROCHEMENT_ERROR"

export const IMPORT_BANCAIRE_BEGIN = "IMPORT_BANCAIRE_BEGIN"
export const IMPORT_BANCAIRE_SUCCESS = "IMPORT_BANCAIRE_SUCCESS"
export const IMPORT_BANCAIRE_ERROR = "IMPORT_BANCAIRE_ERROR"
export const IMPORT_BANCAIRE_RESET = "IMPORT_BANCAIRE_RESET"

export const VALIDER_RAPPROCHEMENT_BEGIN = "VALIDER_RAPPROCHEMENT_BEGIN"
export const VALIDER_RAPPROCHEMENT_SUCCESS = "VALIDER_RAPPROCHEMENT_SUCCESS"
export const VALIDER_RAPPROCHEMENT_ERROR = "VALIDER_RAPPROCHEMENT_ERROR"
export const VALIDER_RAPPROCHEMENT_RESET = "VALIDER_RAPPROCHEMENT_RESET"

export const IGNORER_LIGNES_BEGIN = "IGNORER_LIGNES_BEGIN"
export const IGNORER_LIGNES_SUCCESS = "IGNORER_LIGNES_SUCCESS"
export const IGNORER_LIGNES_ERROR = "IGNORER_LIGNES_ERROR"

export const DESAPPARIER_BEGIN = "DESAPPARIER_BEGIN"
export const DESAPPARIER_SUCCESS = "DESAPPARIER_SUCCESS"
export const DESAPPARIER_ERROR = "DESAPPARIER_ERROR"

export const REOUVRIR_IGNOREE_BEGIN = "REOUVRIR_IGNOREE_BEGIN"
export const REOUVRIR_IGNOREE_SUCCESS = "REOUVRIR_IGNOREE_SUCCESS"
export const REOUVRIR_IGNOREE_ERROR = "REOUVRIR_IGNOREE_ERROR"

export function fetchRapprochement() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: FETCH_RAPPROCHEMENT_BEGIN })
		return fetch(`${URL}api/rapprochement`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch({ type: FETCH_RAPPROCHEMENT_SUCCESS, payload: json })
			})
			.catch(
				catchApiError(dispatch, (e) => ({
					type: FETCH_RAPPROCHEMENT_ERROR,
					payload: e,
				})),
			)
	}
}

export function importBancaire(file) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: IMPORT_BANCAIRE_BEGIN })
		const formData = new FormData()
		formData.append("fichier", file)
		return fetch(`${URL}api/importbancaire`, {
			method: "POST",
			headers: { Authorization: `Bearer ${token}` },
			body: formData,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch({ type: IMPORT_BANCAIRE_SUCCESS, payload: json })
			})
			.catch(
				catchApiError(
					dispatch,
					(e) => ({ type: IMPORT_BANCAIRE_ERROR, payload: e }),
					{ silent: true },
				),
			)
	}
}

export function validerRapprochement(appariements) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: VALIDER_RAPPROCHEMENT_BEGIN })
		return fetch(`${URL}api/rapprochement`, {
			method: "PUT",
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ appariements }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch({ type: VALIDER_RAPPROCHEMENT_SUCCESS, payload: json })
			})
			.catch(
				catchApiError(
					dispatch,
					(e) => ({ type: VALIDER_RAPPROCHEMENT_ERROR, payload: e }),
					{ silent: true },
				),
			)
	}
}

export function ignorerLignes(ligneIds) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: IGNORER_LIGNES_BEGIN })
		return fetch(`${URL}api/rapprochement/ignorer`, {
			method: "PUT",
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ ligne_ids: ligneIds }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch({ type: IGNORER_LIGNES_SUCCESS, payload: json })
			})
			.catch(
				catchApiError(dispatch, (e) => ({
					type: IGNORER_LIGNES_ERROR,
					payload: e,
				})),
			)
	}
}

export function desapparier(ligneId) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: DESAPPARIER_BEGIN })
		return fetch(`${URL}api/rapprochement`, {
			method: "DELETE",
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ ligne_id: ligneId }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch({ type: DESAPPARIER_SUCCESS, payload: json })
			})
			.catch(
				catchApiError(dispatch, (e) => ({
					type: DESAPPARIER_ERROR,
					payload: e,
				})),
			)
	}
}

export function reouvrirIgnoree(ligneId) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: REOUVRIR_IGNOREE_BEGIN })
		return fetch(`${URL}api/rapprochement/ignorer`, {
			method: "DELETE",
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ ligne_id: ligneId }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch({ type: REOUVRIR_IGNOREE_SUCCESS, payload: json })
			})
			.catch(
				catchApiError(dispatch, (e) => ({
					type: REOUVRIR_IGNOREE_ERROR,
					payload: e,
				})),
			)
	}
}
